<template>
      <div :class="{
        'compare-item': true,
        'compare-item_border': visibleBorder
      }">
        <div class="compare-item__header">
          <div class="compare-item__name">
            <h1 class="compare-item__title">
              Дата/Время:
              {{ titleDate }}
            </h1>
            <h3 class="compare-item__subtitle">
              Изменено:
              {{ titleName }}
            </h3>
          </div>
          <ToolbarIcons
            type-img="chevronBottom"
            @click="$emit('show-modal')"
          />
        </div>
        <div class="compare-item__content">
          <slot/>
        </div>

        <div class="compare-item__button">
          <BaseBtnNew
            v-show="restoreButton"
            name="Восстановить версию"
            @click="$emit('restore-version')"
          >
          <HistoryVersionIconNew />
          </BaseBtnNew>
          <!-- <BaseBtn
            v-show="currentNewsId !== firstColData.Id"
            text="Восстановить версию"
            @click-btn="restoreVersion(firstColData.Id)"
          /> -->
        </div>

      </div>
</template>

<script>
// import BaseBtn from '@/components/ui/BaseBtn.vue'
import ToolbarIcons from '@/components/icons/ToolbarIcons.vue'
import BaseBtnNew from '../ui/BaseBtnNew.vue'
import HistoryVersionIconNew from '@/components/icons/HistoryVersionIconNew.vue'

export default {
  name: 'StoryChangeCompareItem',
  components: {
    BaseBtnNew,
    ToolbarIcons,
    HistoryVersionIconNew
  },
  props: {
    titleDate: {
      type: String,
      default: ''
    },
    titleName: {
      type: String,
      default: ''
    },
    restoreButton: {
      type: Boolean,
      default: false
    },
    visibleBorder: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.compare-item {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  width: 50%;
  padding: 0 25px 0;
  border-right: 2px solid #C8C8C8;

  &:last-child {
    border-right: none;
  }

  &__header {
    display: flex;
    @include flex-center;
  }

  &__name {
    padding: 25px;
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #000000;
  }

  &__title {
    margin-bottom: 12px;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: -0.02em;
  }

  &__content {
    flex: 1;
  }

  &__button {
    position: sticky;
    @include flex-center;
    bottom: 30px;
    width: 100%;
  }
}

</style>
